import type { ISelectItem } from "../types";

const FORMAT_OPTION_KEY = "formatOptionReflection";

export default function Optionable(formatOption: (entity: any) => ISelectItem) {
  return function (target: any) {
    Reflect.defineMetadata(FORMAT_OPTION_KEY, formatOption, target);
  };
}

export function getFormatOptions(target: any) {
  return Reflect.getMetadata(FORMAT_OPTION_KEY, target) as ((entity: any) => ISelectItem) | undefined;
}
